import { dequal } from 'dequal'
import {
  CubeReducerState,
  ValidationResult
} from 'modules/Cube/domain/cube.domain.types'
import {
  getOriginalScheduleDuration,
  getPhasesDuration
} from 'modules/Cube/domain/postActionStages/queries/getContractDuration'
import { DEFAULT_VALIDATION_MESSAGES } from '../messages.quote'

/**
 * An amendment's phases are the whole schedule as it will be once executed, so
 * they have to add up to the same length as the schedule being amended. Both
 * sides being open ended counts as a match.
 */
export const contractDurationMatchesAmendedSchedule = (
  prevState: CubeReducerState
): ValidationResult[] | null => {
  const isAmendment = prevState.data.quote.dealType === 'AMENDMENT'
  const originalPhases = prevState.data.quote.amendment?.original.phases ?? []

  if (!isAmendment || !originalPhases.length) {
    return null
  }

  const isMatchingDuration = dequal(
    getPhasesDuration(prevState),
    getOriginalScheduleDuration(originalPhases)
  )

  if (isMatchingDuration) {
    return null
  }

  return [{ message: DEFAULT_VALIDATION_MESSAGES.AMENDMENT_CONTRACT_DURATION }]
}
